module.exports = __webpack_public_path__ + "static/media/excel_48x1.eb7880f5.svg";